import IconArrow from 'images/icon_arrow.svg'
import * as React from 'react'
import { ListGroup } from 'react-bootstrap'

interface Props {
  items: ListItemProps[]
  className?: string
  style?: React.CSSProperties
}

export interface ListItemProps {
  label: string
  path?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

const Component: React.FC<Props> = ({ items, className, style }) => {
  return (
    <ListGroup variant="flush" className={className} style={style}>
      {items.map(({ label, path, onClick }, index) => (
        <ListGroup.Item className="d-flex justify-content-between align-items-center py-3 mt-1" action href={path} onClick={onClick} key={index}>
          <div>{label}</div>
          <div>
            <img src={IconArrow} alt="arrow" />
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  )
}

export default Component
